import { useDensity } from '../../../contexts/DensityContext';
import { CapacityValidationControl } from './CapacityValidation';
import DateTimePicker from '../../../components/DateTimePicker';
import TypeAhead, { type TypeAheadOption } from '../../../components/TypeAhead';

// API date-only strings must stay in local calendar time, without a UTC conversion.
export function CapacityDateInput({ value, onChange, ariaLabel, disabled, className, mode = 'date' }: {
  value: string;
  onChange: (value: string) => void;
  ariaLabel: string;
  disabled?: boolean;
  className?: string;
  mode?: 'date' | 'time';
}) {
  const compact = useDensity();
  const parsed = value ? new Date(mode === 'date' ? `${value}T00:00:00` : `2000-01-01T${value}:00`) : null;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <DateTimePicker
    mode={mode}
    value={parsed && !Number.isNaN(parsed.getTime()) ? parsed : null}
    onChange={next => onChange(next instanceof Date
      ? mode === 'date' ? `${next.getFullYear()}-${pad(next.getMonth() + 1)}-${pad(next.getDate())}` : `${pad(next.getHours())}:${pad(next.getMinutes())}`
      : '')}
    labelType="none"
    ariaLabel={ariaLabel}
    inputVariant={compact ? 'compact' : 'modal'}
    autoApply
    autoFlip
    usePortal
    use24Hour
    disabled={disabled}
    className={className}
  />;
}

export function Select({ label, value, options, onChange, required = false, disabled = false }: {
  label: string;
  required?: boolean;
  disabled?: boolean;
  value: string;
  options: (string | TypeAheadOption)[];
  onChange: (value: string) => void;
}) {
  const compact = useDensity();
  return <CapacityValidationControl name={label}>{compact && <span className="mb-1 block text-xs font-medium text-label">{label}{required && <span aria-hidden="true" className="text-red-600"> *</span>}</span>}<TypeAhead
    label={compact ? undefined : required ? `${label} *` : label}
    ariaLabel={label}
    value={value}
    disabled={disabled}
    options={options.filter(option => option !== '').map(option => typeof option === 'string' ? { value: option, label: option } : option)}
    onChange={onChange}
    allowClear={options.includes('')}
    placeholder={`Choose ${label.toLowerCase()}`}
  /></CapacityValidationControl>;
}
